"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var component_1 = __importDefault(require("@loadable/component"));
var react_1 = require("react");
var actions_1 = require("../../../contexts/lootbox/actions");
var selectors_1 = require("../../../contexts/lootbox/selectors");
var useRequests_1 = __importDefault(require("../../../hooks/useRequests"));
var constants_1 = require("../constants");
var ImageSequence = (0, component_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require("./ImageSequence")); }); });
var PlayScreen = function (_a) {
    var framerate = _a.framerate, show = _a.show, onError = _a.onError;
    var cashInRewardMiniGame = (0, useRequests_1.default)().cashInRewardMiniGame;
    var _b = (0, react_1.useState)(0), progress = _b[0], setProgress = _b[1];
    var _c = (0, react_1.useState)(constants_1.openFiles), sequence = _c[0], setSequence = _c[1];
    var interval = (0, react_1.useRef)();
    var miniGame = (0, selectors_1.useActiveLootBox)();
    var prize = (0, selectors_1.useLootBoxPrize)();
    var _d = (0, selectors_1.useCampaignDetails)(), playerId = _d.playerId, campaignId = _d.campaignId, customerId = _d.customerId;
    var dispatch = (0, selectors_1.useDispatch)();
    var minFrame = 10;
    var maxFrame = 25;
    var canShowPrize = (0, react_1.useMemo)(function () { return Object.keys(prize).length > 0; }, [prize]);
    var clearAnimation = function () {
        clearInterval(interval.current);
        interval.current = undefined;
    };
    var startOpenAnimation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var animateDown_1, prize_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!show) return [3 /*break*/, 5];
                    if (interval.current) {
                        clearAnimation();
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    animateDown_1 = false;
                    interval.current = setInterval(function () {
                        setProgress(function (currentProgress) {
                            if (!canShowPrize) {
                                if (currentProgress === minFrame) {
                                    animateDown_1 = false;
                                }
                                if (currentProgress === maxFrame) {
                                    animateDown_1 = true;
                                }
                                if (animateDown_1) {
                                    return currentProgress - 1;
                                }
                                return currentProgress + 1;
                            }
                            if (currentProgress === 100) {
                                startLoopAnimation();
                                return 0;
                            }
                            if (currentProgress < 100) {
                                return currentProgress + 1;
                            }
                            return currentProgress;
                        });
                    }, framerate);
                    if (!!canShowPrize) return [3 /*break*/, 3];
                    return [4 /*yield*/, cashInRewardMiniGame({
                            playerId: playerId,
                            campaignId: campaignId,
                            gameId: miniGame.id,
                            customerId: customerId,
                        })];
                case 2:
                    prize_1 = _a.sent();
                    dispatch((0, actions_1.setLootBoxPrize)(prize_1));
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    onError();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var startLoopAnimation = function () {
        clearInterval(interval.current);
        interval.current = undefined;
        setSequence(constants_1.loopFiles);
        interval.current = setInterval(function () {
            setProgress(function (currentProgress) {
                if (currentProgress === 99) {
                    return 0;
                }
                return currentProgress + 1;
            });
        }, framerate);
    };
    (0, react_1.useEffect)(function () {
        startOpenAnimation();
    }, [show, canShowPrize]);
    if (!show) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--playScreen" }, { children: canShowPrize && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--title" }, { children: "Felicit\u0103ri! Ai c\u00E2\u0219tigat" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--prize" }, { children: prize.title })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--sequence-hint" }, { children: "Te a\u0219tept\u0103m \u0219i m\u00E2ine cu noi cadouri surpriz\u0103." }))] }) })), (0, jsx_runtime_1.jsx)(ImageSequence, __assign({ progress: progress, sequence: sequence }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", className: "secondary-button" }, { children: "\u00CEnapoi" })) }))] }));
};
exports.default = PlayScreen;
